import { Component, Input } from '@angular/core';
import { AlarmOverview, Application } from 'projects/customerportal/src/app/interfaces/alarm';
import { Observable } from 'rxjs';
import { DataPointsResult } from 'projects/customerportal/src/app/interfaces/data-points';
import { SchematicsService } from '../../../services/schematics.service';
import { AppModel } from '@ams/dumbledore';
import { Installation } from '../../../interfaces/facilty';
import { MixitX509BannerComponent } from '../../mixit-x509-banner/mixit-x509-banner.component';
import { AsyncPipe } from '@angular/common';
import { AlarmBarComponent } from '../../alarms/alarm-bar/alarm-bar.component';
import { SchematicsTileComponent } from '../../schematics-tile/schematics-tile.component';
import { WaterMeterChartTileComponent } from '../../charts/water-meter-chart-tile/water-meter-chart-tile.component';

@Component({
    selector: 'app-cold-water-supply-dashboard',
    templateUrl: './cold-water-supply-dashboard.component.html',
    styleUrls: ['./cold-water-supply-dashboard.component.scss'],
    imports: [
    MixitX509BannerComponent,
    AlarmBarComponent,
    SchematicsTileComponent,
    WaterMeterChartTileComponent,
    AsyncPipe
]
})
export class ColdWaterSupplyDashboardComponent {
  @Input() public alarm$: Observable<AlarmOverview>;
  @Input() application: Application;
  @Input() public installation$: Observable<Installation>;
  @Input() public schematic$: Observable<AppModel>;
  @Input() public dataPoints$: Observable<DataPointsResult>;

  constructor(private schematicService: SchematicsService) {}
}
